import {createSlice} from '@reduxjs/toolkit';
import {constants} from '../../../util/constants';

export const paramSlice = createSlice({
    name: 'param',
    initialState: {
        params: constants.jdsnApps
    },
    reducers: {
        setParams: (state, actions) => {
            state.params = actions.payload;
        }
    }
});

export const {setParams} = paramSlice.actions;
export default paramSlice.reducer;
